import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { BarChart3, LayoutGrid, LifeBuoy, Layers, Users } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const LINKS = [
  ["/admin", "Hub", LayoutGrid],
  ["/admin/sales", "Sales", BarChart3],
  ["/admin/users", "Members", Users],
  ["/admin/drafts", "Tracks", Layers],
  ["/admin/rescue-stuck-checkouts", "Rescue", LifeBuoy],
];

// Phone/tablet quick-nav for the back office. Marks <body class="sv-admin"> so admin tables scroll instead of overflowing.
export function AdminMobileNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isAdmin = pathname.startsWith("/admin") && user && typeof user === "object" && user.role === "admin";
  useEffect(() => {
    document.body.classList.toggle("sv-admin", !!isAdmin);
    if (isAdmin) document.documentElement.style.setProperty("--sv-sticky-h", "56px");
    return () => { document.body.classList.remove("sv-admin"); if (isAdmin) document.documentElement.style.removeProperty("--sv-sticky-h"); };
  }, [isAdmin]);
  if (!isAdmin) return null;
  return (
    <nav className="fixed inset-x-0 bottom-0 z-[60] border-t border-purple-500/30 bg-[#07050b]/95 backdrop-blur-md lg:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }} aria-label="Admin quick navigation" data-testid="admin-mobile-nav">
      <ul className="grid h-14 grid-cols-5">
        {LINKS.map(([to, label, Icon]) => {
          const active = to === "/admin" ? pathname === "/admin" : pathname.startsWith(to);
          return (
            <li key={to} className="flex">
              <Link to={to} className={`flex flex-1 flex-col items-center justify-center gap-0.5 text-xs font-semibold ${active ? "text-purple-200" : "text-zinc-400"}`} aria-current={active ? "page" : undefined} data-testid={`admin-mobile-nav-${label.toLowerCase()}`}>
                <Icon size={18} aria-hidden="true" />{label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
